<template>
  <a :href="userProfile && userProfile.Slug && linkToProfile
    ? `/pages/profile/${userProfile.Slug}`
    : ''
    " :class="GetFinalClass(userProfile)" :title='GetAvatarTitle()'>

    <vs-avatar v-if="userProfile && (userProfile.avatarUrl && userProfile.avatarUrl.length > 0)"
               :src="userProfile.avatarUrl"
      :size="size ? size : '128px'" :style="styleProp" :color="color" />

    <vs-avatar v-else
      :style="styleProp" :color="color" :size="size ? size : '128px'"
      v-bind:text="userProfile && userProfile.Slug && userProfile.Slug.length > 2
    ? userProfile.Slug.toLowerCase().substring(0, 3)
    : 'N/A'
    "></vs-avatar>
    <p v-if="showName && userProfile" class="product-name font-medium">{{ userProfile.FirstName }} {{
    userProfile.LastName }}</p>
  </a>
</template>
<script>

import TCVelikClient from '@/TCVelikClient/TCVelikClient.js';

export default {
  methods: {
    GetFinalClass(user) {
      if (this.MarkExEmployees) {
        if (user && user.Tags && user.Tags.filter(t => t.Item.Title === "Ex-Employee").length > 0) {
          return "ex-employee";
        }
      }
    },
    GetAvatarTitle() {
      if (this.userProfile && this.userProfile.FirstName) {
        return this.userProfile.FirstName + " " + this.userProfile.LastName;
      }
      else if (this.userProfile && this.userProfile.Email) {
        return this.userProfile.Email;
      }
    },
    GetUserImage(user) {
      if (user.AvatarAsset && user.AvatarAsset.Uid) {
        return TCVelikClient.GetDAMDownloadUrl(user.AvatarAsset);
      }
      else if (user.UserImageUrl) {
        return user.UserImageUrl;
      }
    }
  },
  props: ["userProfile", "size", "styleProp", "color", "linkToProfile", "showName", "MarkExEmployees"],
};
</script>

<style scoped>
*>>>.ex-employee {
  filter: grayscale(1);
}

.user-avatar {
  font-size: 20px;
  float: left;
  margin-right: 10px;
}

.ex-employee {
  filter: grayscale(1);
}
</style>
